import { FC } from 'react';
import { Link } from '@carbon/react';
import { CheckmarkFilled } from '@carbon/react/icons';
import type { StructuredPartyDetail } from './types';
import { ENTITY_TYPE_LABEL } from './reconcile/types';
import style from './user-added-confirmed-card.module.scss';

interface Props {
  party: StructuredPartyDetail;
}

export const UserAddedConfirmedCard: FC<Props> = ({ party }) => {
  const entity = party.confirmedEntity;
  if (!entity) return null;

  return (
    <div className={style.card}>
      <div className={style.header}>
        <span className={style.eyebrow}>User Added</span>
        <span className={style.confirmedBadge}>
          <CheckmarkFilled size={16} /> Confirmed
        </span>
      </div>

      <h5 className={style.name}>
        <Link href={`/entities/${entity.id}`}>{entity.name ?? '—'}</Link>
      </h5>

      <dl className={style.fields}>
        <div className={style.field}>
          <dt>Role</dt>
          <dd>{party.role || '—'}</dd>
        </div>
        <div className={style.field}>
          <dt>Entity Type</dt>
          <dd>{ENTITY_TYPE_LABEL[entity.type]}</dd>
        </div>
        <div className={style.field}>
          <dt>Entity ID</dt>
          <dd>{entity.id}</dd>
        </div>
        <div className={style.field}>
          <dt>Address</dt>
          <dd>{entity.primaryAddress?.fullText || '—'}</dd>
        </div>
        {entity.secondaryAddress && (
          <div className={style.field}>
            <dt>Secondary Address</dt>
            <dd>{entity.secondaryAddress.fullText}</dd>
          </div>
        )}
        <div className={style.field}>
          <dt>Phone</dt>
          <dd>{entity.phoneNumber || '—'}</dd>
        </div>
        {entity.emailAddress && (
          <div className={style.field}>
            <dt>Email</dt>
            <dd>{entity.emailAddress}</dd>
          </div>
        )}
      </dl>
    </div>
  );
};
